if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
    });
    $('.reviews').slick({
        accessibility: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows:false,
                    dots: true,
                    adaptiveHeight:true
                }
            }
        ]
    });

    if($('.blog__filter').length > 0){
        $('.blog__filter ul li').click(function(){
            const thisTag = $(this).attr('data-tag');
                $('.card').hide();
                $('.card.'+thisTag).fadeIn();
                $('.blog__filter ul li').removeClass('active');
                $(this).addClass('active');
        });
    }

    if(document.querySelector('.js-open-menu-mobile')){
        const openMenu = document.querySelector('.js-open-menu-mobile');
        const closeMenu = document.querySelector('.close-menu');
        openMenu.addEventListener('click', function(){
            document.querySelector('.navigation').classList.add('show');
        });
        closeMenu.addEventListener('click', function(){
            document.querySelector('.navigation').classList.remove('show');
        })
    }

})(); 